import React from "react";
import { Box, Button, CircularProgress } from "@mui/material";

const StepFooterActions = ({
  activeStep,
  onBack,
  onNext,
  isLastStep,
  loading,
  disabled,
}) => {
  const nextLabel = isLastStep ? "Submit" : "Save & Continue";

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        pt: 3,
        borderTop: "1px solid #E6ECEA",
      }}
    >
      <Button
        onClick={onBack}
        disabled={activeStep === 0 || loading}
        sx={{
          borderRadius: 2,
          color: "#3A4441",
          fontWeight: 600,
          textTransform: "none",
          "&:hover": { backgroundColor: "#F1F3F2" },
        }}
      >
        Back
      </Button>

      <Button
        onClick={onNext}
        variant="contained"
        disabled={loading || disabled}
        startIcon={
          loading ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : null
        }
        sx={{
          borderRadius: 2,
          backgroundColor: "#0E7A6E",
          fontWeight: 600,
          textTransform: "none",
          boxShadow: "none",
          "&:hover": { backgroundColor: "#0B5F56", boxShadow: "none" },
          "&.Mui-disabled": {
            backgroundColor: loading || disabled ? "#0E7A6E" : undefined,
            color: loading || disabled ? "#fff" : undefined,
            opacity: loading || disabled ? 1 : undefined,
          },
        }}
      >
        {loading ? "Saving..." : nextLabel}
      </Button>
    </Box>
  );
};

export default StepFooterActions;
